var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelled = function SvgCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32h16V16H16zm8 12q-4.149 0-7.8-1.575T9.85 38.15q-2.7-2.7-4.275-6.35T4 24t1.575-7.8T9.85 9.85t6.35-4.275Q19.851 4 24 4q4.15 0 7.8 1.575t6.35 4.275 4.275 6.35T44 24t-1.575 7.8-4.275 6.35-6.35 4.275T24 44"
  })));
};
export default SvgCancelled;